import { IconButton, Tooltip } from '@elkaso-app/web-design';
import React from 'react';
import { FiEye, FiFileText, FiTag } from 'react-icons/fi';

export interface ActionsCellProps {
  mappingId: number;
  entityName: string;
  currentLicenseNumber?: string;
  onView: (mappingId: number) => void;
  onEditBrand: (mappingId: number) => void;
  onEditLicense: (mappingId: number) => void;
}

export const ActionsCell: React.FC<ActionsCellProps> = ({
  mappingId,
  entityName,
  currentLicenseNumber: _currentLicenseNumber,
  onView,
  onEditBrand,
  onEditLicense,
}) => {
  return (
    <div
      style={{
        height: '80px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '8px 0',
        gap: '6px',
      }}>
      <Tooltip label={`View ${entityName} details`}>
        <IconButton
          aria-label={`View ${entityName} details`}
          icon={<FiEye />}
          size='sm'
          colorScheme='blue'
          variant='outline'
          onClick={() => onView(mappingId)}
        />
      </Tooltip>
      <Tooltip label={`Edit brand mapping`}>
        <IconButton
          aria-label={`Edit brand mapping`}
          icon={<FiTag />}
          size='sm'
          colorScheme='green'
          variant='outline'
          onClick={() => onEditBrand(mappingId)}
        />
      </Tooltip>
      <Tooltip label={`Map trade license`}>
        <IconButton
          aria-label={`Map trade license`}
          icon={<FiFileText />}
          size='sm'
          colorScheme='orange'
          variant='outline'
          onClick={() => onEditLicense(mappingId)}
        />
      </Tooltip>
    </div>
  );
};
